import React, { useState } from "react"
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"

export default function CollapsibleSection({
  title,
  children,
  defaultOpen = true,
}) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <Accordion
      expanded={open}
      onChange={() => setOpen(!open)}
      elevation={0}
      sx={{
        bgcolor: "transparent",
        mb: 2,
        "&:before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        sx={{
          px: 0,
          "& .MuiAccordionSummary-content": {
            m: 0,
            display: "flex",
            alignItems: "center",
            gap: 1.2,
          },
        }}
      >
        {/* Left Arrow */}
        {open ? (
          <ExpandMoreIcon sx={{ color: "text.heading" }} />
        ) : (
          <ChevronRightIcon sx={{ color: "text.heading" }} />
        )}

        {/* Title */}
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 16,
            color: "text.heading",
          }}
        >
          {title}
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ px: 0, pt: 1 }}>{children}</AccordionDetails>
    </Accordion>
  )
}
